import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { clearStoreNewReports, getServicesMaxMin } from "../store/thunk";
import { FiAlertTriangle, FiSearch } from 'react-icons/fi';
import { Table } from "../../../components/Table";
import { CartesianGrid, Legend, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, Line } from "recharts";
import { useEffect } from "react";



export const MaxMin = () => {

    /**
     * ToDo:
     *  - Este reporte solo esta activo para produccion.
     */





    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes; let today = f.getFullYear() + "-" + mes + "-" + dia;
    const dispatch = useDispatch();
    const { isLoading, servicesMaxMin, dateStart, dateEnd, msg } = useSelector(state => state.newReports);
    const { register, control, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({ model: 'all' });

    function transformData(data) {
        const agrupaciones = {};

        data.forEach(row => {
            if (!agrupaciones[row.AGRUPACION]) {
                agrupaciones[row.AGRUPACION] = { AGRUPACION: row.AGRUPACION };
            }
            agrupaciones[row.AGRUPACION][row.NOMBRE] = row.CONTEO;
        });

        return Object.values(agrupaciones);
    }

    const chartData = transformData(servicesMaxMin);
    const servicios = [...new Set(servicesMaxMin.map(d => d.NOMBRE))];

    const searchData = (data) => {
        dispatch(getServicesMaxMin(data.fechaInicial, data.fechaFinal, data.periodo, data.opcion, data.extraer))
    }

    let serviciosData = [...servicesMaxMin];
    let columns = [
        {
            header: 'PERIODO',
            dataIndex: 'AGRUPACION',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'SERVICIO',
            dataIndex: 'NOMBRE',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'SOLICITADO',
            dataIndex: 'CONTEO',
            classHeader: 'text-end',
            classRow: 'text-end',
        },

    ];

    // Ajuste grafico
    const maxValue = Math.max(...chartData.flatMap(d =>
        servicios.map(servicio => d[servicio] || 0)
    ));

    const yAxisMax = Math.ceil((maxValue + 2) / 2) * 2; // redondeo opcional

    useEffect(() => {
        dispatch(clearStoreNewReports())
    }, [])

    return (
        <div className='row'>


            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div className='card'>
                    <div className='card-header border-bottom'>
                        <h4 className="h4 fw-bold"> Servicios Maximos y Minimos</h4>
                    </div>
                    <div className='card-body'>
                        <form className="row " onSubmit={handleSubmit(searchData)}>
                            <div className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-2">
                                <label className="form-label">Fecha Inicio:</label>
                                <input type="date" className="form-control" defaultValue={today} {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                                {
                                    errors.fechaInicial &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                                    </div>
                                }
                            </div>
                            <div className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-2">
                                <label className="form-label">Fecha Inicio:</label>
                                <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal", { required: 'Introduce fecha final' })} />
                                {
                                    errors.fechaFinal &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaFinal.message}</small></span>
                                    </div>
                                }
                            </div>

                            <div className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-2">
                                <label className="form-label">Periodo:</label>
                                <select className="form-select" aria-label="Default select example" {...register("periodo", { required: 'Seleccione peridoo' })}>
                                    <option value="1">Dia</option>
                                    <option value="2">Semana</option>
                                    <option value="3">Mes</option>
                                </select>
                                {
                                    errors.periodo &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.periodo.message}</small></span>
                                    </div>
                                }
                            </div>

                            <div className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-2">
                                <label className="form-label">Max | Min:</label>
                                <select className="form-select" aria-label="Default select example" {...register("opcion", { required: 'Seleccione max | min' })}>
                                    <option value="1">Mas solicitado</option>
                                    <option value="2">Menos solicitado</option>

                                </select>
                                {
                                    errors.opcion &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.opcion.message}</small></span>
                                    </div>
                                }
                            </div>

                            <div className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-2">
                                <label className="form-label">Extraer</label>
                                <input type="number" className="form-control" defaultValue={10} {...register("extraer", { required: 'Cantidad de registros a extraer' })} ></input>
                                {
                                    errors.extraer &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.extraer.message}</small></span>
                                    </div>
                                }
                            </div>

                            <div className='col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mt-4'>
                                <button type="submit" className="btn btn-outline-dark mt-1">  <FiSearch size={20} /> Buscar</button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div className="card">
                    <div className="card-header border-bottom ">
                        <h5 className="card-title mb-0 text-black">Grafico</h5>
                    </div>
                    <div className="card-body">
                        {/* <ResponsiveContainer width="100%" height={400}>
                            <LineChart data={chartData}>
                                <CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
                                <XAxis dataKey="AGRUPACION" />
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                {servicios.map((nombre, idx) => (
                                    <Line key={idx} type="monotone" dataKey={nombre} stroke={`hsl(${idx * 60}, 70%, 50%)`} strokeWidth={2} />
                                ))}
                            </LineChart>
                        </ResponsiveContainer> */}

                        <ResponsiveContainer width="100%" height={400}>
                            <LineChart data={chartData}>
                                <CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
                                <XAxis dataKey="AGRUPACION" />
                                <YAxis domain={[0, yAxisMax]} />
                                <Tooltip />
                                <Legend />
                                {servicios.map((nombre, idx) => (
                                    <Line
                                        key={idx}
                                        type="monotone"
                                        dataKey={nombre}
                                        stroke={`hsl(${idx * 60}, 70%, 50%)`}
                                        strokeWidth={2}
                                    />
                                ))}
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>


                <div className="card">
                    <div className="card-header border-bottom ">
                        <h5 className="card-title mb-0 text-black">Listado de Servicios</h5>
                    </div>
                    <div className="card-body">
                        <Table columns={columns} data={serviciosData} function_={[]} placeholderSearch="Buscar servicio"
                            showPagination={true} showControls={true} showTotals={false} />
                    </div>
                </div>
            </div>
        </div>
    )
}
